import { NgZone } from "@angular/core";

export function inZone(
  zone: NgZone,
  callback: (...args: any[]) => void,
  applyThis?: any,
  applyArgs?: any[],
): void {
  zone.run(() => {
    callback.apply(applyThis, applyArgs);
  });
}

export function inZoneFn(
  zone: NgZone,
  callback: (...args: any[]) => void,
  applyThis?: any,
  applyArgs?: any[],
): () => void {
  return () => {
    inZone(zone, callback, applyThis, applyArgs);
  };
}
